
<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
               <img src="assets/images/logos/logo_RIC.png">
            </div>

            <div class="title">LOGIN</div>

            <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
              <div>
                <mat-form-field appearance="outline">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="loginForm.get('email').hasError('required')">
                        Email es requerido
                    </mat-error>
                    <mat-error
                        *ngIf="!loginForm.get('email').hasError('required') &&
                                loginForm.get('email').hasError('email')">
                        Ingresar un correo valido
                    </mat-error>
                </mat-form-field>
              </div>
              <div>
                <mat-form-field appearance="outline">
                    <mat-label>Password</mat-label>
                    <input matInput type="password" formControlName="password">
                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                    <mat-error>
                        Password es obligatorio
                    </mat-error>
                </mat-form-field>

              </div>

              <div>
                <div *ngIf="tokenDeshabilitado">
                    <mat-label style="color:red">Debe habilitar el ZofToken.</mat-label>
                </div>
                <div *ngIf="tokenBloqueado">
                    <mat-label style="color:red">El ZofToken esta bloqueado, pongase en contacto con el administrador.</mat-label>
                </div>

                <div *ngIf="!enrolado">
                    <mat-label >Su usuario no esta registrado a ZofToken aun, escanee el siguiente codigo para registrarse.</mat-label>
                    <img [src]="ztQr" alt="Token" />
                </div>
              </div>


                <button mat-raised-button color="accent" class="submit-button" aria-label="Ingresar"
                        [disabled]="loginForm.invalid">
                    Ingresar
                </button>

            </form>


        </div>

    </div>

</div>
